// extracted by mini-css-extract-plugin
export var sliderRange = "_cs-2";
export var sliderRoot = "_cs-0";
export var sliderThumb = "_cs-3";
export var sliderTrack = "_cs-1";